import React from 'react';
import { useTranslation } from 'react-i18next';

function MobileEmailAuthBtn({
  btnType,
  handleChangeBtn,
  handleSend
}) {
  const { t } = useTranslation();
  return (
    <div className="click_line area1">
      {(() => {
        switch (btnType) {
          case 'change':
            return (
              <button
                type="button"
                className="mint_txt_btn"
                onClick={() => handleChangeBtn("auth")}
              >
                {t("MY_03_01-GM.msg003")}
              </button>
            )
          case 'auth':
            return (
              <button
                type="button"
                className="mint_txt_btn hide_pc hide_t"
                onClick={handleSend}
              >
                {t("MY_03_01-GM.msg004")}
              </button>
            )
          case 'resend':
            return (
              <button
                type="button"
                className="mint_txt_btn hide_pc hide_t"
                onClick={handleSend}
              >
                {t("MY_03_01-GM.msg005")}
              </button>
            )
          default:
            break;
        }
      })()}
    </div>
  );
}

export default MobileEmailAuthBtn;